import PropTypes from 'prop-types'
import React, { Component } from 'react'
import classNames from 'classnames'
import style from './style.scss'

export default class Loading extends Component {
    static propTypes = {
        children: PropTypes.node,
        className: PropTypes.string,
        delay: PropTypes.number,
        inverted: PropTypes.bool,
        label: PropTypes.string,
        size: PropTypes.oneOf(['small', 'large']).isRequired,
        style: PropTypes.object,
    }

    static defaultProps = {
        size: 'small',
        delay: 300,
    }

    constructor(props) {
        super(props)
        
        this.state = {
            showLoader: props.delay === 0
        }
        this.timer = null
    }

    
    componentWillUnmount() {
        if (this.timer) {
            clearTimeout(this.timer)
            this.timer = null
        }
    }
    
    render() {
        const {
            children,
            className,
            delay,
            inverted,
            label,
            size,
            style:inlineStyle
        } = this.props

        if (!this.timer && delay > 0) {
            this.timer = setTimeout(() => {
                this.setState({ showLoader: true })
            }, delay)
        }

        const { showLoader } = this.state

        if (!showLoader) {
            return null
        }

        const containerClass = classNames(style.container, style[size], { [style.inverted]: inverted }, className)

        const imgPath = `/static-assets/${inverted ? 'loader-inverted' : 'loader'}.gif`
        const content = typeof children === 'string' ? <span>{children}</span> : children

        return (
            <span className={containerClass} style={inlineStyle}>
                <img alt={label || 'loading'} aria-hidden="true" src={imgPath} />
                {label && <span>{label}</span>}
                {content}
            </span>
        )
    }
}



// WEBPACK FOOTER //
// src/components/loading/index.js